import { defineMessages } from 'react-intl';

export default defineMessages({
  addToCartSingleItem: {
    id: 'Pdp.addToCartPDPContainer.button.singleItem.text',
    defaultMessage: 'Add to Cart',
  },
  addToCartMultipleItems: {
    id: 'Pdp.addToCartPDPContainer.button.multipleItems.text',
    defaultMessage: 'Add Items to Cart',
  },
  disabledATCAddToCart: {
    id: 'Pdp.addToCartPDPContainer.button.disabledATCaddToCart.text',
    defaultMessage: 'Buy Online (Coming Soon)',
  },
});
